import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgShaprLogoNoPadding = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4134 12.08V4.29008L15.9999 0L3.38049 7.30067V16.922L8.5863 19.92V27.7099L15.9999 32L28.6192 24.6993V15.078L23.4134 12.08ZM16.9532 2.54645L21.6572 5.25598V11.0639L16.9532 8.32928V2.54645ZM15.034 29.4535L10.3299 26.7315V20.9236L15.034 23.6582V29.4535ZM15.9999 22.1654L5.32483 15.9937L15.9999 9.82203L26.6623 15.9937L15.9999 22.1654Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShaprLogoNoPadding);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=ShaprLogoNoPadding.svg.js.map
